<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import FormSingleUpload from '../../../../app/components/form/SingleUpload.vue'
  import FormTinymce from '../../../../app/components/form/Tinymce.vue'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'
  import bus from '@utils/bus'
  import baseConfig from '../../../../config'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton, FormSingleUpload, FormTinymce},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          name: '',
          description: '',
          image: {
            name: '',
            type: '',
            size: '',
            base64: ''
          },
          content: ''
        },
        dependencies: {}
      }
    },
    validations: {
      form: {
        name: {required},
        description: {required},
        image: {required}
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('signature', null, id)
          .then(response => {
            const image = {
              name: response.image,
              type: '',
              size: '',
              base64: ''
            }
            response.image = image
            this.form = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      } else {
        this.isLoadingData = false
        bus.$emit('hide-loader')
      }
    },
    computed: {
      getSignatureImage: function () {
        return baseConfig.basePath + 'files/' + this.form.image.name
      }
    },
    methods: {
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        restfulService.save('signature', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'signature.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Assinatura dos Certificados"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados da Assinatura</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     @submit.native.prevent>
                <el-form-item label="Nome"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.name.$error }">
                    <el-input v-model="form.name"
                              @input="$v.form.name.$touch()"/>
                    <div class="el-form-item__error" v-if="$v.form.name.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Descrição"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.description.$error }">
                    <el-input v-model="form.description"
                              @input="$v.form.description.$touch()"/>
                    <div class="el-form-item__error" v-if="$v.form.description.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Imagem"
                              class="is-required">
                    <form-single-upload :model.sync="form.image"
                                        accepted-types="image/*">
                    </form-single-upload>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted"/>
                    <form-cancel-button route-name="signature.index"/>
                </el-form-item>
                <el-form-item>
                    <div class="preview-image" :style="'background-image: url('+getSignatureImage+')'"></div>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<style lang="scss" scoped>
    .preview-image {
        width: 180px;
        height: 100px;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        border: 1px solid #ddd;
    }
</style>



// WEBPACK FOOTER //
// Form.vue?6f1df547